var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-checkbox-group"},[_c('CheckboxGroup',_vm._g(_vm._b({},'CheckboxGroup',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.optionList),function(item,i){return _c('Checkbox',{key:i,attrs:{"label":item.value,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }